export default "__VITE_ASSET__225be9ce__"